import React, { useState, useEffect } from "react";
import { MessageCircle, Send, ArrowUp } from "lucide-react";
import { contact } from "../mock";

const FloatingButtons = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed left-4 bottom-4 z-50 flex flex-col items-center gap-3">
      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="h-11 w-11 grid place-items-center rounded-full bg-[#12131f] border border-[#00ff87]/30 text-[#00ff87] hover:bg-[#00ff87] hover:text-black transition-colors"
          aria-label="Scroll to top"
        >
          <ArrowUp size={20} />
        </button>
      )}
      <a
        href={contact.telegram}
        target="_blank"
        rel="noreferrer"
        className="h-13 w-13 grid place-items-center rounded-full bg-[#229ED9] text-white shadow-lg hover:scale-105 transition-transform"
        style={{ height: 52, width: 52 }}
        aria-label="Telegram"
      >
        <Send size={24} />
      </a>
      <a
        href={contact.whatsapp}
        target="_blank"
        rel="noreferrer"
        className="grid place-items-center rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform animate-pulse-glow"
        style={{ height: 56, width: 56 }}
        aria-label="WhatsApp"
      >
        <MessageCircle size={26} />
      </a>
    </div>
  );
};

export default FloatingButtons;
